import {
  validateFormat,
  validatePresence,
} from 'ember-changeset-validations/validators';

export const BookingDotComPublishLegalDetailsValidation = {
  contactName: validatePresence({ presence: true, ignoreBlank: true }),
  contactEmail: [
    validatePresence({ presence: true, ignoreBlank: true }),
    validateFormat({ type: 'email' }),
  ],
  contactLanguage: validatePresence({ presence: true }),
  contactPhoneType: validatePresence({ presence: true }),
  invoiceLegalCompanyName: validatePresence({
    presence: true,
    ignoreBlank: true,
  }),
  invoiceContactName: validatePresence({
    presence: true,
    ignoreBlank: true,
  }),
  invoiceCountry: validatePresence({ presence: true }),
  invoiceAddress: validatePresence({ presence: true, ignoreBlank: true }),
  invoiceCity: validatePresence({ presence: true, ignoreBlank: true }),
  invoiceZipCode: validatePresence({ presence: true, ignoreBlank: true }),
};
